import React,{useEffect} from 'react'
import Navbar from '../../../components/Navbar'
import Footer from '../../../components/Footer'
const Termsandcondition = () => {
    useEffect(() => {
        window.scrollTo(0,0)
        }, [])
  return (
   <>
    <Navbar/>
      <section id='p-policy'>
                <div className='or-div'>
                    <h1>Terms and Conditions</h1>
                </div>

                <div className="container ">

                    <p className='mt-opo'>
                        Lorem Ipsum is simply dummy text of the printing a
                        nd typesetting industry. Lorem Ipsum has been the industry's stand
                        ard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.


                    </p>

                    <div className='mt-opo'>
                        <h3>Terms and Conditions</h3>

                        <ol>
                            <li> <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p> </li>
                            <li> <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                                Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.

                            </p> </li>
                            <li> <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p> </li>
                            <li> <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                                Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.

                            </p> </li>
                          
                            <li> <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                                Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.

                            </p> </li>
                            <li> <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p> </li>
                            <li> <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                                Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.

                            </p> </li>
                           

                        </ol>
                    </div>


                
                    <div className='mt-opo'>
                        <h3>Your Account</h3>

                        <p className='mt-opo'>
                            Lorem Ipsum is simply dummy text of the printing a
                            nd typesetting industry. Lorem Ipsum has been the industry's stand
                            ard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.


                        </p>
                    </div>
                    <div className='mt-opo'>
                        <h3>Your Conduct</h3>

                        <p className='mt-opo'>
                            Lorem Ipsum is simply dummy text of the printing a
                            nd typesetting industry. Lorem Ipsum has been the industry's stand
                            ard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.


                        </p>
                    </div>
                    <div className='mt-opo'>
                        <h3>Copyright & Trademark</h3>

                        <ol>
                            <li> <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p> </li>
                            <li> <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                                Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.

                            </p> </li>
                            <li> <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p> </li>
                            <li> <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                                Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.

                            </p> </li>
                          
                            <li> <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                                Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.

                            </p> </li>
                            <li> <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p> </li>
                            <li> <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                                Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.

                            </p> </li>
                           

                        </ol>
                    </div>
                </div>
            </section>
            <Footer/>
   </>
  )
}

export default Termsandcondition